<script setup>
// T-229 — a confirmação antes de o e-mail sair.
//
// Até 23/09 este componente era um compositor: tinha a própria área de texto, o próprio campo de
// anexo, e o agente escrevia ali. Ficou apertado, e o motivo é estrutural: ao lado existe a caixa
// de resposta de sempre, grande, com editor, respostas prontas e anexo. Manter duas caixas obriga
// o agente a aprender duas.
//
// Agora ele escreve na caixa de sempre e isto só pergunta se pode mandar, e para onde. É a última
// tela antes de conteúdo de atendimento sair para um endereço que pode estar desatualizado, então
// o endereço aparece em destaque, não em letra miúda.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['confirm']);

const { t } = useI18n();
const dialogRef = ref(null);
const destino = ref('');
const resumo = ref('');
const quantosAnexos = ref(0);

const open = ({ email, texto, anexos = 0 } = {}) => {
  destino.value = email || '';
  resumo.value = (texto || '').trim();
  quantosAnexos.value = anexos;
  dialogRef.value?.open();
};

const confirmar = () => {
  emit('confirm');
  dialogRef.value?.close();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CONVERSATION.RESPOSTA_EMAIL.TITULO')"
    :confirm-button-label="t('CONVERSATION.RESPOSTA_EMAIL.ENVIAR')"
    @confirm="confirmar"
  >
    <div class="flex flex-col gap-3">
      <p class="text-sm text-n-slate-11">
        {{ t('CONVERSATION.RESPOSTA_EMAIL.PERGUNTA') }}
      </p>

      <div
        class="px-3 py-2 text-sm font-medium break-all rounded-lg text-n-slate-12 bg-n-alpha-2"
      >
        {{ destino }}
      </div>

      <!-- O texto aparece para conferência, cortado: quem está confirmando já escreveu, e o que
           importa aqui é reconhecer, não reler. -->
      <p
        class="px-3 py-2 overflow-hidden text-sm rounded-lg text-n-slate-11 bg-n-alpha-1 line-clamp-4"
      >
        {{ resumo }}
      </p>

      <p v-if="quantosAnexos" class="text-xs text-n-slate-11">
        {{ t('CONVERSATION.RESPOSTA_EMAIL.COM_ANEXOS', { n: quantosAnexos }) }}
      </p>

      <p class="text-xs text-n-slate-11">
        {{ t('CONVERSATION.RESPOSTA_EMAIL.AVISO') }}
      </p>
    </div>
  </Dialog>
</template>
